import Cookies from "universal-cookie";
import { isDefined } from "../utils";
import { Errors } from "../errors";
import { SESSION_BASE_URL } from "../lib/constants/urls";

const cookies = new Cookies(null, { path: "/" });

class CSRFController {
  private cookie_name = "csrf";

  async fetch() {
    const response = await fetch(`${SESSION_BASE_URL}/token`, {
      credentials: "include",
    });
    if (!response.ok) {
      throw new Error(Errors.CSRFLoadFailed);
    }
    cookies.update();
    return cookies.get(this.cookie_name);
  }

  get() {
    return cookies.get(this.cookie_name);
  }

  async getOrFetch() {
    if (this.isValid()) {
      return this.get();
    }
    return await this.fetch();
  }

  isValid() {
    return isDefined(this.get());
  }
}

const csrfController = new CSRFController();
export default csrfController;
